export const RESERVED_CRITERIA_CODE = {
  AUTOMAKER_GROUP: 'AUTOMAKER_GROUP',
  COUNTRY: 'COUNTRY',
  CUSTOMER: 'CUSTOMER',
  LEVEL: 'LEVEL',
} as const;
